import { IPerfectScrollState } from "../scroll/perfectScrollModel";
import { ICustomScrollStore } from "./CustomScrollStoreModel";
import { buildSetOffsetsOnScrollReducer } from "../_features/setOffsetsOnScroll/setOffsetsOnScrollReducer";
import { customScrollStatusReducer } from "./customScrollStatus";

/*
 */
export const buildCustomScrollStore = isRtl =>
    buildStore(
        combineReducers<IPerfectScrollState>({
            isRtl: state => state,
            horizontalDimension: buildSetOffsetsOnScrollReducer("x"),
            verticalDimension: buildSetOffsetsOnScrollReducer("y"),
            options: (state, { type, options }) =>
                type == "setOptions" ? options : state,
            status: customScrollStatusReducer,
        }),
        isRtl
    );

/*
 */
const logActivity = false;

export function buildStore(
    reducer: IReducer<IPerfectScrollState>,
    isRtl: boolean
): ICustomScrollStore {
    let state: IPerfectScrollState = {
        isRtl,
    } as any;

    let subscriptions = [];
    let store;

    const getState = () => state;

    const dispatch = buildDispatchRoutine(
        () => store,
        reducer,
        () => subscriptions,
        s => (state = s)
    );

    const buildUnsubscribeFn = listener => () => {
        subscriptions = subscriptions.filter(x => x !== listener);
    };

    return (store = {
        getState,
        dispatch,
        subscribe: listener => {
            subscriptions = subscriptions.concat(listener);
            return buildUnsubscribeFn(listener);
        },
    });
}

function buildDispatchRoutine(getStore, reducer, getSubscriptions, setState) {
    const laterActions = new LinkedList();
    let isNotifying = false;

    const dispatch = action => {
        const store = getStore();
        logActivity && console.log(action);
        if (typeof action == "function") action(store.getState, store.dispatch);
        else {
            setState(reducer(store.getState(), action));
            try {
                isNotifying = true;
                const subscriptions = getSubscriptions();
                for (const listener of subscriptions) listener(store);
            } finally {
                isNotifying = false;
            }
        }
        logActivity && console.log(store.getState());
    };

    return action => {
        laterActions.append(action);
        if (isNotifying) return;

        while (laterActions.canPrepend()) {
            dispatch(laterActions.prepend());
        }
    };
}

class LinkedList<T = any> {
    private next;
    private last;

    append = (item: T) => {
        if (!this.next) this.last = this.next = { item };
        else this.last = this.last.next = { item };
    };

    canPrepend = () => !!this.next;

    prepend = (): T => {
        if (!this.next)
            throw new Error(
                "Noting to prepend. Test by canPrepend() before prepend()"
            );

        const { item, next } = this.next;
        this.next = next;
        if (!this.next) this.last = null;

        return item;
    };
}

/*
 */
interface IReducer<S, A = any> {
    (state: S, action: A): S;
}

type TReducers<T> = {
    [K in keyof T]: IReducer<T[K]>;
};

export function combineReducers<T>(reducers: TReducers<T>): IReducer<T> {
    const keys = Object.keys(reducers);
    return (state = null, action) => {
        const newState = {} as T;
        let changed = false;
        for (const key of keys) {
            const oldSubState = state[key];
            const newSubState = reducers[key](oldSubState, action);
            changed = changed || newSubState !== oldSubState;
            newState[key] = newSubState;
        }
        return changed ? newState : state;
    };
}
